function getPackLimits(input) {
  const step = parseFloat(input.step) || 1;
  const min = parseFloat(input.min) || 0;
  const max = parseFloat(input.max);

  let maxValid = Infinity;

  if (!isNaN(max)) {
    maxValid = min + Math.floor((max - min) / step) * step;
  }

  return { step, min, maxValid };
}

function updatePackQtyButtons(input) {
  if (!input || !input.matches('input.input-pack-qty[type="number"]')) return;

  const wrapper = input.closest('.input-amount');
  if (!wrapper) return;

  const plusBtn = wrapper.querySelector('.incr');
  const minusBtn = wrapper.querySelector('.decr');
  const value = parseFloat(input.value) || 0;
  const { min, maxValid } = getPackLimits(input);

  if (plusBtn) {
    const disablePlus = value >= maxValid;
    plusBtn.classList.toggle('is-disabled', disablePlus);
    plusBtn.setAttribute('aria-disabled', disablePlus ? 'true' : 'false');
  }

  if (minusBtn) {
    const disableMinus = value <= min;
    minusBtn.classList.toggle('is-disabled', disableMinus);
    minusBtn.setAttribute('aria-disabled', disableMinus ? 'true' : 'false');
  }
}

function snapPackQtyToValidStep(value, min, step, maxValid) {
  if (isNaN(value)) return min;

  // borne d'abord
  if (value < min) value = min;
  if (value > maxValid) value = maxValid;

  // aligne sur le multiple inférieur à partir de min
  const offset = value - min;
  const snapped = min + Math.floor(offset / step) * step;

  // sécurité finale
  if (snapped < min) return min;
  if (snapped > maxValid) return maxValid;

  return snapped;
}

function normalizePackQty(input, shouldDispatchChange = false) {
  if (!input || !input.matches('input.input-pack-qty[type="number"]')) return;

  const { step, min, maxValid } = getPackLimits(input);
  const previousValue = input.value;
  let value = parseFloat(input.value);

  if (Number.isFinite(maxValid)) {
    input.max = String(maxValid);
  }

  value = snapPackQtyToValidStep(value, min, step, maxValid);

  input.value = String(value);
  updatePackQtyButtons(input);

  if (shouldDispatchChange && String(previousValue) !== String(value)) {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

function setPackQtyValue(input, nextValue) {
  if (!input || !input.matches('input.input-pack-qty[type="number"]')) return;

  const { step, min, maxValid } = getPackLimits(input);

  if (Number.isFinite(maxValid)) {
    input.max = String(maxValid);
  }

  const value = snapPackQtyToValidStep(nextValue, min, step, maxValid);

  input.value = String(value);
  updatePackQtyButtons(input);

  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function normalizePackQtyInScope(scope) {
  if (!scope) return false;

  const qtyInputs = scope.querySelectorAll('input.input-pack-qty[type="number"]');
  if (!qtyInputs.length) return false;

  let hasChanged = false;

  qtyInputs.forEach((input) => {
    const before = String(input.value);
    normalizePackQty(input, true);
    const after = String(input.value);

    if (before !== after) {
      hasChanged = true;
    }
  });

  return hasChanged;
}

// Garde-fou final : toute quantité envoyée au panier pour un produit vendu par lot
// est ramenée sur un multiple du lot (minimum 1 lot). Couvre aussi les champs cachés
// (QuickView, cartes sans sélecteur) que normalizePackQty ne traite pas.
function enforcePackQtyOnForm(form) {
  if (!form) return false;

  let hasChanged = false;

  form.querySelectorAll('input.input-pack-qty[type="number"]').forEach((input) => {
    const before = input.value;
    normalizePackQty(input);
    if (input.value !== before) hasChanged = true;
  });

  form.querySelectorAll('input[name="quantity"][data-pack-qty]').forEach((input) => {
    const pack = parseInt(input.dataset.packQty, 10);
    if (!pack || pack < 1) return;

    const current = parseInt(input.value, 10) || 0;
    const snapped = Math.max(pack, Math.floor(current / pack) * pack);

    if (snapped !== current) {
      input.value = String(snapped);
      hasChanged = true;
    }
  });

  return hasChanged;
}

document.addEventListener('click', function (e) {
  const plusBtn = e.target.closest('.input-amount .incr');
  const minusBtn = e.target.closest('.input-amount .decr');

  if (!plusBtn && !minusBtn) return;

  const wrapper = e.target.closest('.input-amount');
  const input = wrapper?.querySelector('input.input-pack-qty[type="number"]');
  if (!input) return;

  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') {
    e.stopImmediatePropagation();
  }

  const currentValue = parseFloat(input.value) || 0;
  const { step, min, maxValid } = getPackLimits(input);

  if (plusBtn) {
    if (currentValue >= maxValid) {
      setPackQtyValue(input, maxValid);
      return;
    }

    setPackQtyValue(input, currentValue + step);
    return;
  }

  if (minusBtn) {
    if (currentValue <= min) {
      setPackQtyValue(input, min);
      return;
    }

    setPackQtyValue(input, currentValue - step);
  }
}, true);

document.addEventListener('submit', function (e) {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;

  if (form.__packQtyResubmitting) {
    form.__packQtyResubmitting = false;
    return;
  }

  enforcePackQtyOnForm(form);
  const hasChanged = normalizePackQtyInScope(form);
  if (!hasChanged) return;

  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') {
    e.stopImmediatePropagation();
  }

  form.__packQtyResubmitting = true;

  requestAnimationFrame(() => {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(e.submitter || undefined);
    } else {
      form.submit();
    }
  });
}, true);

document.addEventListener('click', function (e) {
  const addBtn = e.target.closest(
    '[data-row-add-to-cart], .overlay-buy_button, [name="add"], .product-form__submit, .add-to-cart'
  );
  if (!addBtn) return;

  const row = addBtn.closest('[data-variant-row]');
  const scope = row || addBtn.closest('form') || addBtn.closest('article') || document;
  const qtyInputs = scope.querySelectorAll('input.input-pack-qty[type="number"]');

  qtyInputs.forEach((input) => {
    normalizePackQty(input, true);
  });
}, true);

document.addEventListener('pointerdown', function (e) {
  const addBtn = e.target.closest(
    '[data-row-add-to-cart], .overlay-buy_button, [name="add"], .product-form__submit, .add-to-cart'
  );
  if (!addBtn) return;

  const row = addBtn.closest('[data-variant-row]');
  const scope = row || addBtn.closest('form') || addBtn.closest('article') || document;

  normalizePackQtyInScope(scope);
}, true);

document.addEventListener('mousedown', function (e) {
  const addBtn = e.target.closest(
    '[data-row-add-to-cart], .overlay-buy_button, [name="add"], .product-form__submit, .add-to-cart'
  );
  if (!addBtn) return;

  const row = addBtn.closest('[data-variant-row]');
  const scope = row || addBtn.closest('form') || addBtn.closest('article') || document;

  normalizePackQtyInScope(scope);
}, true);

document.addEventListener('input', function (e) {
  const input = e.target.closest('input.input-pack-qty[type="number"]');
  if (!input) return;

  updatePackQtyButtons(input);
});

document.addEventListener('change', function (e) {
  const input = e.target.closest('input.input-pack-qty[type="number"]');
  if (!input) return;

  if (input.__packQtySyncing) return;

  const before = String(input.value);

  normalizePackQty(input, false);

  const after = String(input.value);

  // Si on a corrigé la valeur (ex: 64 -> 63),
  // on bloque l'événement initial pour éviter que le thème/cart
  // traite l'ancienne valeur invalide.
  if (before !== after) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    input.__packQtySyncing = true;

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    requestAnimationFrame(() => {
      input.__packQtySyncing = false;
      normalizePackQty(input, false);
    });

    return;
  }

  requestAnimationFrame(() => {
    normalizePackQty(input, false);
  });
}, true);

document.addEventListener('blur', function (e) {
  const input = e.target.closest('input.input-pack-qty[type="number"]');
  if (!input) return;

  normalizePackQty(input);

  requestAnimationFrame(() => {
    normalizePackQty(input);
  });
}, true);

document.addEventListener('keydown', function (e) {
  const input = e.target.closest('input.input-pack-qty[type="number"]');
  if (!input) return;

  const currentValue = parseFloat(input.value) || 0;
  const { step, min, maxValid } = getPackLimits(input);

  if (e.key === 'ArrowUp') {
    e.preventDefault();
    setPackQtyValue(input, currentValue + step);
  }

  if (e.key === 'ArrowDown') {
    e.preventDefault();
    setPackQtyValue(input, currentValue - step < min ? min : currentValue - step);
  }
});

document.addEventListener('wheel', function (e) {
  const input = e.target.closest('input.input-pack-qty[type="number"]');
  if (!input) return;

  e.preventDefault();
}, { passive: false });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('input.input-pack-qty[type="number"]').forEach(normalizePackQty);
});